module.exports = __webpack_public_path__ + "img/maintenance_problem.b8b0d67a.svg";